import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    CollapsableCardTitle,
    CollapsableCardImageContainer,
} from 'src/styles/CommonStyles.styled';

export const InvoiceImageContainer = styled(CollapsableCardImageContainer)`
    order: ${({ isOrder }) => (isOrder ? isOrder : 3)};

    ${media.mobileDevice`
        order:  ${({ isOrder }) => (isOrder ? isOrder : 2)};
    `}
`;

export const InvoiceTitleContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    ${media.smalDevice`
        flex-wrap:wrap;
    `}
    ${media.mobileDevice`
        flex-wrap:wrap;
    `}
`;

export const CardTitleText = styled(CollapsableCardTitle)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    ${media.mobileDevice`
        white-space: normal;
        overflow: initial;
        text-overflow: unset;
    `}
`;

export const InvoiceDetailContainer = styled.div`
    width: 100%;
    display: flex;
    margin-top: 16px;
    ${media.mobileDevice`
        margin-left: ${({ mobileMarginLeft }) =>
            mobileMarginLeft ? mobileMarginLeft : 'unset'};
    `}
`;

export const InvoiceDataContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin: 0 1rem 0 0;
`;

export const TitleContainer = styled.div`
    width: 40%;
    order: 1;
    ${media.smalDevice`
        width: 90%;
    `}
    ${media.mobileDevice`
        width: 95%;
        display: ${({mbDisplay})=>(mbDisplay)};
    `}
    @media only screen and (max-device-width: 360px) {
        width: 85%;
    }
`;

export const InvoiceCreatedContainer = styled.div`
    width: 60%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    order: 2;
    ${media.smalDevice`
    width: 100%;
        order: 4;
        justify-content: flex-start;
        margin-left: 6px;
        margin-top: 5px;
        `}
    ${media.mobileDevice`
        order: 3;
        width: 100%;
        justify-content: flex-start;
        flex-wrap : wrap;
        margin-left: 0px;
    `}
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    width: ${({ width }) => width};
    white-space: ${({ whiteSpace }) => whiteSpace};
    overflow: ${({ overflow }) => overflow};
    text-overflow: ${({ textOverFlow }) => textOverFlow};

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before {
                content: ' | ';
                opacity: 20%;
            },
            &:after {
                content: ' | ';
            }
        `}
    ${media.smalDevice`
    width: auto;
        white-space: unset;
        overflow:unset;
        text-overflow:unset;
        `}
    ${media.mobileDevice`
        font-size: 10px;
        margin: ${({ mobileMargin }) =>
            mobileMargin ? mobileMargin : '0 5px 0 0'};
            width: auto;
        white-space: unset;
        overflow:unset;
        text-overflow:unset;
        `}
`;
export const WrapperContainer = styled.div`
    display: flex;
    width: ${({ width }) => width};
    max-width: ${({ maxWidth }) => maxWidth};
    ${media.smalDevice`
    width: auto;
        max-width:unset;
        `}
    ${media.mobileDevice`
         width: auto;
         max-width:unset;
    `}
`;
